<template>
  <div class="sc__accordion">
    <a
      :id="`ScAccordionHeader-${id}`"
      href="#"
      class="sc__accordion__cta"
      :aria-expanded="isExpanded ? 'true' : 'false'"
      :aria-controls="`ScAccordionPanel-${id}`"
      @click.prevent="onCtaClick"
    >
      {{ cta }}
    </a>

    <div
      v-show="isExpanded"
      :id="`ScAccordionPanel-${id}`"
      class="sc__accordion__content"
      :hidden="isExpanded ? false : true"
    >
      <slot />
    </div>
  </div>
</template>

<script src="./index.js"></script>

<style scoped lang="scss">
@import './style.scss';
</style>
